import { gql } from '@apollo/client';

export default gql`
  query getPortalBanners($branch: String) {
    getPortalBanners(branch: $branch) {
      ok
      error
      data {
        _id
        type
        order
        name
        nameAr
        lang
        data {
          connectType
          connectId
          uri
          order
          mobile
          desktop
          mwidth
          mheight
          dwidth
          dheight
          type
        }
        disabled
        createdAt
        updatedAt
      }
    }
  }
`;
